export const LabeledEventTypes = [
    { value: 'onClick', label: 'On Click' },
    { value: 'onDialogClose', label: 'On Dialog Close' }
];
export const EventTypes = LabeledEventTypes.map(type => type.value);
//# sourceMappingURL=SiteEventPlugin.js.map